const eq = (a, b) => (a || '').trim().toLowerCase() === (b || '').trim().toLowerCase();
const unique = (values) => [...new Map(values.filter(Boolean).map((v) => [v.toLowerCase(), v])).values()]
  .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));

export const sizeGroupsFor = (rows, type, style, make, model) => {
  if (!type || !style || !make || !model) return [];
  const scoped = rows.filter((r) => eq(r.equipment_type, type) && eq(r.style, style));
  const used = new Set();
  return [
    { label: 'Saved for this model', options: scoped.filter((r) => eq(r.manufacturer, make) && eq(r.model, model)).flatMap((r) => r.sizes || []) },
    { label: 'Manufacturer reference sizes', options: scoped.filter((r) => eq(r.manufacturer, make) && !r.model).flatMap((r) => r.reference_sizes || []) },
    { label: 'Style reference sizes', options: scoped.filter((r) => !r.manufacturer && !r.model).flatMap((r) => r.reference_sizes || []) },
  ].map((group) => ({ ...group, options: unique(group.options).filter((v) => {
    const key = v.toLowerCase();
    if (used.has(key)) return false;
    used.add(key); return true;
  }) })).filter((group) => group.options.length);
};

// Parent changes clear dependent values; opening/editing an existing record does not.
export const equipmentCascadePatch = (item, field, value) => {
  if (item[field] === value) return { [field]: value };
  const fields = ['equipment_type', 'style', 'make', 'model', 'size'];
  return { [field]: value, ...Object.fromEntries(fields.slice(fields.indexOf(field) + 1).map((f) => [f, ''])) };
};